import { render, staticRenderFns } from "./ledParam_page.vue?vue&type=template&id=6693e97d&scoped=true"
import script from "./ledParam_page.vue?vue&type=script&lang=js"
export * from "./ledParam_page.vue?vue&type=script&lang=js"
import style0 from "./ledParam_page.vue?vue&type=style&index=0&id=6693e97d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6693e97d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6693e97d')) {
      api.createRecord('6693e97d', component.options)
    } else {
      api.reload('6693e97d', component.options)
    }
    module.hot.accept("./ledParam_page.vue?vue&type=template&id=6693e97d&scoped=true", function () {
      api.rerender('6693e97d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/led/ledParam_page.vue"
export default component.exports